import {
  grayColor,
  whiteColor,
  container,
  title,
  main,
  mainRaised,
  section,
  mrAuto,
  mlAuto,
  defaultFont,
} from '../../../coscef';

import imagesStyles from '../../imagesStyles';
import customSelectStyle from '../../customSelectStyle';

const sectionAddStyle = {
  main,
  mainRaised,
  container,
  mrAuto,
  mlAuto,
  ...customSelectStyle,
  title: {
    ...title,
    marginBottom: '25px',
  },
  sections: {
    padding: '70px 0',
  },
  section: {
    textAlign: 'center',
  },
  sectionWhite: {
    background: whiteColor,
  },
  quoteText: {
    fontSize: '1.5rem !important',
  },
  ...imagesStyles,
  sectionfinal: {
    ...section,
    padding: '70px 0px',
    textAlign: 'center',
  },
  marginTop35: {
    marginTop: '35px',
  },
  marginLeft20: {
    marginLeft: '20px',
  },
  textCenter: {
    textAlign: 'center!important',
  },
  control: {
    margin: '0 0 17px 0',
    paddingTop: '30px',
  },
  control1: {
    paddingTop: '28px',
  },
  label: {
    ...defaultFont,
    color: grayColor[1] + ' !important',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '1.42857',
    top: '10px',
    letterSpacing: 'unset',
    '& + $underline': {
      marginTop: '0px',
    },
  },
  floatRight: {
    float: 'right',
  },
  floatLeft: {
    float: 'left',
  },
  circleBar: {
    width: '40px',
    height: '40px',
    display: 'inline-block',
  },
};

export default sectionAddStyle;
